<div class="inline-icon-with-text">
  <label class="form-label me-2">
    <strong>{{ label }}</strong>
  </label>
  <om-tooltip [text]="tooltip"></om-tooltip>
</div>
